// Load self-hosted webfonts asynchronously after first paint so they
// stay off the critical request chain. System fallbacks render
// immediately; fonts swap in once downloaded (font-display: swap).
let started = false;
export function loadFontsWhenIdle() {
  if (started || typeof window === "undefined") return;
  started = true;
  const run = () => {
    void import("@fontsource/inter/latin-400.css");
    void import("@fontsource/inter/latin-500.css");
    void import("@fontsource/inter/latin-600.css");
    void import("@fontsource/inter/latin-700.css");
    void import("@fontsource/playfair-display/latin-600.css");
    void import("@fontsource/playfair-display/latin-700.css");
    void import("@fontsource/great-vibes/latin-400.css");
  };
  const ric = (window as any).requestIdleCallback as
    | ((cb: () => void, opts?: { timeout: number }) => number)
    | undefined;
  if (ric) ric(run, { timeout: 2000 });
  else setTimeout(run, 200);
}
